/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CouponCode,
  Courier,
  CourierBill,
  CourierGenerateMonthlyBillRequest,
  CourierRegenerateMarketingInfoRequest,
  CourierSettings,
  CourierUserCreateWhatsAppUserRequest,
  ImageGalleryItem,
  MailOption,
  NewCouponCode,
  NewCourier,
  NewCourierBill,
  NewPushSubscription,
  NewRewardsAccount,
  NewStoreLocation,
  OneSignal,
  Plan,
  PushSubscription,
  RewardSettings,
  RewardsAccount,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  StoreLocation,
  ThemeSetting,
  WarehousePackage,
} from '../models/index';
import {
    CouponCodeFromJSON,
    CouponCodeToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierBillFromJSON,
    CourierBillToJSON,
    CourierGenerateMonthlyBillRequestFromJSON,
    CourierGenerateMonthlyBillRequestToJSON,
    CourierRegenerateMarketingInfoRequestFromJSON,
    CourierRegenerateMarketingInfoRequestToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    CourierUserCreateWhatsAppUserRequestFromJSON,
    CourierUserCreateWhatsAppUserRequestToJSON,
    MailOptionFromJSON,
    MailOptionToJSON,
    NewCouponCodeFromJSON,
    NewCouponCodeToJSON,
    NewCourierFromJSON,
    NewCourierToJSON,
    NewCourierBillFromJSON,
    NewCourierBillToJSON,
    NewPushSubscriptionFromJSON,
    NewPushSubscriptionToJSON,
    NewRewardsAccountFromJSON,
    NewRewardsAccountToJSON,
    NewStoreLocationFromJSON,
    NewStoreLocationToJSON,
    OneSignalFromJSON,
    OneSignalToJSON,
    PlanFromJSON,
    PlanToJSON,
    PushSubscriptionFromJSON,
    PushSubscriptionToJSON,
    RewardSettingsFromJSON,
    RewardSettingsToJSON,
    RewardsAccountFromJSON,
    RewardsAccountToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    StoreLocationFromJSON,
    StoreLocationToJSON,
    ThemeSettingFromJSON,
    ThemeSettingToJSON,
} from '../models/index';

export interface CourierCountRequest {
    where?: string;
}

export interface CourierCreateRequest {
    data?: NewCourier;
}

export interface CourierCreateChangeStreamGetCouriersChangeStreamRequest {
    options?: string;
}

export interface CourierCreateChangeStreamPostCouriersChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface CourierCreateNewCourierRequest {
    courier?: Courier;
}

export interface CourierDeleteByIdRequest {
    id: string;
}

export interface CourierExistsGetCouriersidExistsRequest {
    id: string;
}

export interface CourierExistsHeadCouriersidRequest {
    id: string;
}

export interface CourierFetchWarehousePackagesRequest {
    courierId: string;
    time: string;
    forceRefresh?: boolean;
}

export interface CourierFindRequest {
    filter?: string;
}

export interface CourierFindByIdRequest {
    id: string;
    filter?: string;
}

export interface CourierFindOneRequest {
    filter?: string;
}

export interface CourierGenerateMonthlyBillOperationRequest {
    courierGenerateMonthlyBillRequest?: CourierGenerateMonthlyBillRequest;
}

export interface CourierGetDashboardDataRequest {
    request?: object;
}

/** Body of POST /Couriers/getDashboardInsights. Dates are calendar days (YYYY-MM-DD) in the courier's timezone. */
export interface DashboardInsightsQuery {
    /** Required for Overlords (impersonation); ignored-if-equal / 403-if-different for everyone else. */
    courierId?: number;
    from?: string;
    to?: string;
    storeLocationId?: number;
}

export interface CourierGetDashboardInsightsRequest {
    request?: DashboardInsightsQuery;
}

/** A number for the selected period vs the same-length period before it. `change` is a % (null when the previous value was 0). */
export interface DashboardComparison {
    current: number;
    previous: number;
    change: number | null;
}

export interface DashboardStatusCount {
    status: string;
    count: number;
    weight: number;
}

export interface DashboardAgingBucket {
    key: '0-3' | '4-7' | '8-14' | '15-30' | '31+' | 'unknown';
    min: number | null;
    max: number | null;
    count: number;
    owed: number;
}

/** What one cashier took in the period, by tender. `cashierId: null` is the unattributed row (online/bulk-paid). */
export interface DashboardCashierRevenue {
    cashierId: number | null;
    name: string | null;
    count: number;
    cash: number;
    card: number;
    bank: number;
    /** Credit balance + reward points — settled without money changing hands. */
    other: number;
    total: number;
}

export interface DashboardRetailInsights {
    kpis: {
        packagesReceived: DashboardComparison;
        weightReceived: DashboardComparison;
        packagesCollected: DashboardComparison;
        revenueCollected: DashboardComparison;
        billed: DashboardComparison;
        unpaid: DashboardComparison;
        newCustomers: DashboardComparison;
        deliveryRequests: DashboardComparison;
        avgDaysToCollect: { current: number | null; previous: number | null };
    };
    invoices: { billed: number; paid: number; unpaid: number; pendingVerification: number; paidCount: number };
    pipeline: DashboardStatusCount[];
    uncollected: { count: number; weight: number; owed: number; buckets: DashboardAgingBucket[] };
    trends: { keys: string[]; received: number[]; collected: number[]; revenueCollected: number[]; billed: number[] };
    storeRevenue: { storeLocationId: number | null; name: string | null; total: number }[];
    /** Paid revenue per cashier; absent on APIs older than the cashier card. */
    cashierRevenue?: DashboardCashierRevenue[];
    topCustomers: { customerId: number; name: string; revenue: number; packages: number }[];
    /** What this courier owes a warehouse it is a sub-courier of; null when nothing is outstanding. */
    warehouseBalance: { outstanding: number; overdue: number; invoiceCount: number; overdueCount: number; currency: string } | null;
}

export interface DashboardSubCourierRow {
    key: string;
    subCourierId: number | null;
    subCourierUserId: number | null;
    name: string | null;
    billed: number;
    collected: number;
    outstanding: number;
    overdue: number;
    invoices: number;
    packages: number;
    weight: number;
}

export interface DashboardWarehouseInsights {
    currency: string;
    kpis: {
        billed: DashboardComparison;
        collected: DashboardComparison;
        /** Every package received (createdOn), on a manifest or not. */
        packagesReceived: DashboardComparison;
        manifests: DashboardComparison;
        packagesProcessed: DashboardComparison;
        weightProcessed: DashboardComparison;
    };
    snapshot: {
        outstanding: number;
        outstandingCount: number;
        overdue: number;
        overdueCount: number;
        draftCount: number;
        draftTotal: number;
        unbilledPackages: number;
        /** Right now: not delivered and not on any manifest. */
        notOnManifest: number;
        /** Right now: the warehouse's own packages at "Received at Loading Dock". */
        atDock: number;
        /** …of those, received more than 24 hours ago (a scan that never matched, or set aside). Older APIs omit it. */
        atDockStale?: number;
        /** Right now: the warehouse's own packages at "At Warehouse". */
        atWarehouse: number;
    };
    feeBreakdown: { key: string; total: number }[];
    trends: { keys: string[]; billed: number[]; collected: number[] };
    subCouriers: DashboardSubCourierRow[];
    manifests: { id: number; name: string | null; createdOn: string; packages: number; weight: number; billed: number; unbilledPackages: number }[];
    partnerPipeline: DashboardStatusCount[];
}

/**
 * Present on DashboardInsights only when CourierSettings.isExpenseTrackerEnabled is true AND the caller is an
 * Overlord/Administrator. Cash basis, for the same period/previousPeriod as the dashboard.
 */
export interface DashboardExpenseInsights {
    currency: string;
    /** Number(CourierSettings.gct) > 0 */
    gctRegistered: boolean;
    /** True when the dashboard request had a storeLocationId: expenses are not split by store. */
    appliesToAllStores: boolean;
    kpis: {
        /** Recorded expenses only (P&L totalExpenses excluding wages). */
        expenses: DashboardComparison;
        wages: DashboardComparison;
        netProfit: DashboardComparison;
    };
    /** P&L revenue behind netProfit: retail net of GCT plus same-currency warehouse collected. */
    revenueNet: number;
    /** Up to 5, descending. */
    topCategories: { categoryId: number | null; name: string; total: number }[];
    /** Expenses in status 'pending' (any date) awaiting confirmation. */
    pendingCount: number;
    /** Only when gctRegistered. */
    gct?: { outputGct: number; inputGct: number; netPayable: number };
}

export interface DashboardInsights {
    courierId: number;
    mode: 'retail' | 'warehouse';
    timezone: string;
    period: { from: string; to: string; days: number; granularity: 'day' | 'week' | 'month' };
    previousPeriod: { from: string; to: string };
    storeLocationId: number | null;
    generatedAt: string;
    retail?: DashboardRetailInsights;
    warehouse?: DashboardWarehouseInsights;
    expenses?: DashboardExpenseInsights;
}

export type ReadinessStatus = 'ok' | 'warn' | 'fail' | 'skip';

export type ReadinessArea =
    | 'identity' | 'domains' | 'shipping' | 'email'
    | 'whatsapp' | 'warehouse' | 'payments' | 'store';

/** One item of GET /Couriers/:id/readiness. */
export interface ReadinessCheck {
    id: string;
    area: ReadinessArea;
    title: string;
    status: ReadinessStatus;
    detail: string;
    /** What to do about it (present on warn/fail). */
    fix?: string;
    /** Admin-assistant tool that fixes it, when one exists. */
    fixTool?: string;
}

/** Setup readiness checklist for a courier (Overlord only). */
export interface CourierReadiness {
    courier: { id: number; name: string; realm: string; webUrl?: string };
    /** Whether network probes (SMTP login, sites, mail DNS) ran. */
    live: boolean;
    checkedAt: string;
    summary: { ok: number; warn: number; fail: number; skip: number; ready: boolean };
    checks: ReadinessCheck[];
}

export interface CourierGetReadinessRequest {
    id: number;
    /** Also run network probes — slower (~10s). */
    live?: boolean;
}

export interface CourierSendOwnerLoginLinkRequest {
    id: number;
    /** Any of 'whatsapp', 'email' (default both). */
    channels?: Array<'whatsapp' | 'email'>;
}

/** Result of POST /Couriers/:id/send-owner-login. The link itself is never returned. */
export interface CourierOwnerLoginLinkResult {
    success: boolean;
    error?: string;
    courier?: { id: number; name: string; realm: string };
    sentTo?: { ownerUserId: number | string; email: string | null; whatsapp: string | null };
    whatsappSent?: boolean;
    emailSent?: boolean;
    channel?: 'whatsapp+email' | 'whatsapp' | 'email' | 'none';
    skipped?: string[];
}

export interface CourierOwnerContact {
    courierId: number;
    courierName: string;
    realm: string;
    ownerUserId?: number | string;
    ownerName?: string;
    ownerEmail?: string;
    ownerWhatsappPhone?: string;
    missingOwner: boolean;
    missingEmail: boolean;
    missingWhatsapp: boolean;
}

/**
 * Move a courier's email and its owner account's email together.
 *
 * There is no ownerId FK — the owner CourierUser is matched on email + realm
 * against Courier.email — so patching one without the other orphans the owner.
 * This endpoint also moves MailOption.from and rebuilds the Mailgun forwarding
 * route, which a plain PATCH of Courier.email does not.
 */
export interface CourierSetOwnerEmailRequest {
    id: string;
    newEmail: string;
    /** Adopt this account as the owner when the courier currently has none. */
    linkExistingUserId?: number | string;
}

/** An account offered as the owner when the courier has none (409 details). */
export interface CourierOwnerCandidate {
    id: number | string;
    email?: string;
    name?: string | null;
}

export interface CourierSetOwnerEmailResponse {
    success: boolean;
    courierId?: number | string;
    realm?: string;
    ownerLink?: string;
    /** True when the address was already in use and nothing needed to move. */
    unchanged?: boolean;
    changes?: {
        courierEmail?: { from?: string | null; to?: string };
        ownerUser?: { id?: number | string; from?: string | null; to?: string };
        mailOptionFrom?: { from?: string | null; to?: string } | null;
    };
    mailgunRoute?: Record<string, any> | null;
    /** Non-fatal problems — e.g. the Mailgun route could not be rebuilt. */
    warnings?: Array<string>;
    message?: string;
}

export interface CourierGetManifestFileGetCouriersGetManifestFileRequest {
    courierId?: string;
}

export interface CourierImportUsersFrom101Request {
    courierId: string;
}

export interface CourierPatchOrCreateRequest {
    data?: Courier;
}

export interface CourierPrototypeCountCouponCodesRequest {
    id: string;
    where?: string;
}

export interface CourierPrototypeCountCourierBillsRequest {
    id: string;
    where?: string;
}

export interface CourierPrototypeCountPlanCouriersRequest {
    id: string;
    where?: string;
}

export interface CourierPrototypeCountPushSubscribersRequest {
    id: string;
    where?: string;
}

export interface CourierPrototypeCountRewardsAccountsRequest {
    id: string;
    where?: string;
}

export interface CourierPrototypeCountStoreLocationsRequest {
    id: string;
    where?: string;
}

export interface CourierPrototypeCreateCouponCodesRequest {
    id: string;
    data?: NewCouponCode;
}

export interface CourierPrototypeCreateCourierBillsRequest {
    id: string;
    data?: NewCourierBill;
}

export interface CourierPrototypeCreateCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface CourierPrototypeCreateMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface CourierPrototypeCreateOneSignalCredentialsRequest {
    id: string;
    data?: OneSignal;
}

export interface CourierPrototypeCreatePlanCouriersRequest {
    id: string;
    data?: NewCourier;
}

export interface CourierPrototypeCreatePushSubscribersRequest {
    id: string;
    data?: NewPushSubscription;
}

export interface CourierPrototypeCreateRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface CourierPrototypeCreateRewardsAccountsRequest {
    id: string;
    data?: NewRewardsAccount;
}

export interface CourierPrototypeCreateStoreLocationsRequest {
    id: string;
    data?: NewStoreLocation;
}

export interface CourierPrototypeCreateThemeSettingRequest {
    id: string;
    data?: ThemeSetting;
}

export interface CourierPrototypeDeleteCouponCodesRequest {
    id: string;
}

export interface CourierPrototypeDeleteCourierBillsRequest {
    id: string;
}

export interface CourierPrototypeDeletePlanCouriersRequest {
    id: string;
}

export interface CourierPrototypeDeletePushSubscribersRequest {
    id: string;
}

export interface CourierPrototypeDeleteRewardsAccountsRequest {
    id: string;
}

export interface CourierPrototypeDeleteStoreLocationsRequest {
    id: string;
}

export interface CourierPrototypeDestroyByIdCouponCodesRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeDestroyByIdCourierBillsRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeDestroyByIdPlanCouriersRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeDestroyByIdPushSubscribersRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeDestroyByIdRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeDestroyByIdStoreLocationsRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeDestroyCourierSettingRequest {
    id: string;
}

export interface CourierPrototypeDestroyMailOptionRequest {
    id: string;
}

export interface CourierPrototypeDestroyOneSignalCredentialsRequest {
    id: string;
}

export interface CourierPrototypeDestroyRewardSettingRequest {
    id: string;
}

export interface CourierPrototypeDestroyThemeSettingRequest {
    id: string;
}

export interface CourierPrototypeFindByIdCouponCodesRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeFindByIdCourierBillsRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeFindByIdPlanCouriersRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeFindByIdPushSubscribersRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeFindByIdRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeFindByIdStoreLocationsRequest {
    id: string;
    fk: string;
}

export interface CourierPrototypeGetCouponCodesRequest {
    id: string;
    filter?: string;
}

export interface CourierPrototypeGetCouponCodesCourierRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetCourierBillsRequest {
    id: string;
    filter?: string;
}

export interface CourierPrototypeGetCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetCourierSettingCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetMailOptionRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetOneSignalCredentialsRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetPlanRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetPlanCouriersRequest {
    id: string;
    filter?: string;
}

export interface CourierPrototypeGetPushSubscribersRequest {
    id: string;
    filter?: string;
}

export interface CourierPrototypeGetRewardSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetRewardsAccountsRequest {
    id: string;
    filter?: string;
}

export interface CourierPrototypeGetStoreLocationsRequest {
    id: string;
    filter?: string;
}

export interface CourierPrototypeGetStoreLocationsCourierRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface CourierPrototypeGetThemeSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface CourierPrototypePatchAttributesRequest {
    id: string;
    data?: Partial<Courier>;
}

export interface CourierPrototypeUpdateByIdCouponCodesRequest {
    id: string;
    fk: string;
    data?: CouponCode;
}

export interface CourierPrototypeUpdateByIdCourierBillsRequest {
    id: string;
    fk: string;
    data?: CourierBill;
}

export interface CourierPrototypeUpdateByIdPlanCouriersRequest {
    id: string;
    fk: string;
    data?: Courier;
}

export interface CourierPrototypeUpdateByIdPushSubscribersRequest {
    id: string;
    fk: string;
    data?: PushSubscription;
}

export interface CourierPrototypeUpdateByIdRewardsAccountsRequest {
    id: string;
    fk: string;
    data?: RewardsAccount;
}

export interface CourierPrototypeUpdateByIdStoreLocationsRequest {
    id: string;
    fk: string;
    data?: StoreLocation;
}

export interface CourierPrototypeUpdateCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface CourierPrototypeUpdateMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface CourierPrototypeUpdateOneSignalCredentialsRequest {
    id: string;
    data?: OneSignal;
}

export interface CourierPrototypeUpdateRewardSettingRequest {
    id: string;
    data?: RewardSettings;
}

export interface CourierPrototypeUpdateThemeSettingRequest {
    id: string;
    data?: ThemeSetting;
}

export interface CourierRegenerateMarketingInfoOperationRequest {
    courierRegenerateMarketingInfoRequest: CourierRegenerateMarketingInfoRequest;
}

export interface CourierReplaceByIdPostCouriersidReplaceRequest {
    id: string;
    data?: Courier;
}

export interface CourierReplaceByIdPutCouriersidRequest {
    id: string;
    data?: Courier;
}

export interface CourierReplaceOrCreatePostCouriersReplaceOrCreateRequest {
    data?: Courier;
}

export interface CourierReplaceOrCreatePutCouriersRequest {
    data?: Courier;
}

export interface CourierShowRatesRequest {
    courierUserCreateWhatsAppUserRequest?: CourierUserCreateWhatsAppUserRequest;
}

export interface CourierUpdateAllRequest {
    where?: string;
    data?: Courier;
}

export interface CourierUpsertWithWhereRequest {
    where?: string;
    data?: Courier;
}

export interface CourierUpdateOnboardingStatusRequest {
    courierId: string;
    status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED';
}

/**
 *
 */
export class CourierApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async courierCountRaw(requestParameters: CourierCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async courierCount(requestParameters: CourierCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async courierCreateRaw(requestParameters: CourierCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async courierCreate(requestParameters: CourierCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async courierCreateChangeStreamGetCouriersChangeStreamRaw(requestParameters: CourierCreateChangeStreamGetCouriersChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async courierCreateChangeStreamGetCouriersChangeStream(requestParameters: CourierCreateChangeStreamGetCouriersChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.courierCreateChangeStreamGetCouriersChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async courierCreateChangeStreamPostCouriersChangeStreamRaw(requestParameters: CourierCreateChangeStreamPostCouriersChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async courierCreateChangeStreamPostCouriersChangeStream(requestParameters: CourierCreateChangeStreamPostCouriersChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.courierCreateChangeStreamPostCouriersChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierCreateNewCourierRaw(requestParameters: CourierCreateNewCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/createNewCourier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['courier']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async courierCreateNewCourier(requestParameters: CourierCreateNewCourierRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.courierCreateNewCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async courierDeleteByIdRaw(requestParameters: CourierDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async courierDeleteById(requestParameters: CourierDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierExistsGetCouriersidExistsRaw(requestParameters: CourierExistsGetCouriersidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierExistsGetCouriersidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierExistsGetCouriersidExists(requestParameters: CourierExistsGetCouriersidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.courierExistsGetCouriersidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierExistsHeadCouriersidRaw(requestParameters: CourierExistsHeadCouriersidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierExistsHeadCouriersid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async courierExistsHeadCouriersid(requestParameters: CourierExistsHeadCouriersidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.courierExistsHeadCouriersidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierExportReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/export-report/{courierId}`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async courierExportReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierExportReportRaw(initOverrides);
    }

    /**
     */
    async courierFetchWarehousePackagesRaw(requestParameters: CourierFetchWarehousePackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling courierFetchWarehousePackages().'
            );
        }

        if (requestParameters['time'] == null) {
            throw new runtime.RequiredError(
                'time',
                'Required parameter "time" was null or undefined when calling courierFetchWarehousePackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        if (requestParameters['time'] != null) {
            queryParameters['time'] = requestParameters['time'];
        }

        if (requestParameters['forceRefresh'] != null) {
            queryParameters['forceRefresh'] = requestParameters['forceRefresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/fetchWarehousePackages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierFetchWarehousePackages(requestParameters: CourierFetchWarehousePackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{
        data: WarehousePackage[];
        total: number;
    }> {
        const response = await this.courierFetchWarehousePackagesRaw(requestParameters, initOverrides);
        return await response.value() as {
            data: WarehousePackage[];
            total: number;
        };
    }



    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async courierFindRaw(requestParameters: CourierFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Courier>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async courierFind(requestParameters: CourierFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Courier>> {
        const response = await this.courierFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async courierFindByIdRaw(requestParameters: CourierFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async courierFindById(requestParameters: CourierFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async courierFindOneRaw(requestParameters: CourierFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async courierFindOne(requestParameters: CourierFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierGenerateMonthlyBillRaw(requestParameters: CourierGenerateMonthlyBillOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/generateMonthlyBill`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierGenerateMonthlyBillRequestToJSON(requestParameters['courierGenerateMonthlyBillRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierGenerateMonthlyBill(requestParameters: CourierGenerateMonthlyBillOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierGenerateMonthlyBillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierGetDashboardDataRaw(requestParameters: CourierGetDashboardDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/getDashboardData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['request'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierGetDashboardData(requestParameters: CourierGetDashboardDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierGetDashboardDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Redesigned admin dashboard: retail or warehouse insights for a period.
     */
    async courierGetDashboardInsightsRaw(requestParameters: CourierGetDashboardInsightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardInsights>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/getDashboardInsights`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (requestParameters['request'] ?? {}) as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Redesigned admin dashboard: retail or warehouse insights for a period.
     */
    async courierGetDashboardInsights(requestParameters: CourierGetDashboardInsightsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardInsights> {
        const response = await this.courierGetDashboardInsightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send the courier owner an admin-portal password-reset link by WhatsApp and/or email (Overlord only).
     */
    async courierSendOwnerLoginLinkRaw(requestParameters: CourierSendOwnerLoginLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierOwnerLoginLinkResult>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierSendOwnerLoginLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/send-owner-login`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['channels'] ? { channels: requestParameters['channels'] } : {},
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Send the courier owner an admin-portal password-reset link by WhatsApp and/or email (Overlord only).
     */
    async courierSendOwnerLoginLink(requestParameters: CourierSendOwnerLoginLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierOwnerLoginLinkResult> {
        const response = await this.courierSendOwnerLoginLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Setup readiness checklist for a courier, each item with a fix hint (Overlord only).
     */
    async courierGetReadinessRaw(requestParameters: CourierGetReadinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierReadiness>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierGetReadiness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['live'] != null) {
            queryParameters['live'] = requestParameters['live'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/readiness`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Setup readiness checklist for a courier, each item with a fix hint (Overlord only).
     */
    async courierGetReadiness(requestParameters: CourierGetReadinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierReadiness> {
        const response = await this.courierGetReadinessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierListOwnerContactsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierOwnerContact>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/owner-contacts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierListOwnerContacts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierOwnerContact>> {
        const response = await this.courierListOwnerContactsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Change the courier email and the owner account's email in one call.
     */
    async courierSetOwnerEmailRaw(requestParameters: CourierSetOwnerEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSetOwnerEmailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierSetOwnerEmail().'
            );
        }
        if (requestParameters['newEmail'] == null) {
            throw new runtime.RequiredError(
                'newEmail',
                'Required parameter "newEmail" was null or undefined when calling courierSetOwnerEmail().'
            );
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/owner-email`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: {},
            body: {
                newEmail: requestParameters['newEmail'],
                ...(requestParameters['linkExistingUserId'] != null
                    ? { linkExistingUserId: requestParameters['linkExistingUserId'] }
                    : {}),
            },
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Change the courier email and the owner account's email in one call.
     */
    async courierSetOwnerEmail(requestParameters: CourierSetOwnerEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSetOwnerEmailResponse> {
        const response = await this.courierSetOwnerEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierGetManifestFileGetCouriersGetManifestFileRaw(requestParameters: CourierGetManifestFileGetCouriersGetManifestFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/getManifestFile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierGetManifestFileGetCouriersGetManifestFile(requestParameters: CourierGetManifestFileGetCouriersGetManifestFileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierGetManifestFileGetCouriersGetManifestFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierImportUsersFrom101Raw(requestParameters: CourierImportUsersFrom101Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling courierImportUsersFrom101().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/import-users-from-101/{courierId}`.replace(`{${"courierId"}}`, encodeURIComponent(String(requestParameters['courierId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierImportUsersFrom101(requestParameters: CourierImportUsersFrom101Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierImportUsersFrom101Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async courierPatchOrCreateRaw(requestParameters: CourierPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async courierPatchOrCreate(requestParameters: CourierPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts couponCodes of Courier.
     */
    async courierPrototypeCountCouponCodesRaw(requestParameters: CourierPrototypeCountCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCountCouponCodes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts couponCodes of Courier.
     */
    async courierPrototypeCountCouponCodes(requestParameters: CourierPrototypeCountCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierPrototypeCountCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierBills of Courier.
     */
    async courierPrototypeCountCourierBillsRaw(requestParameters: CourierPrototypeCountCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCountCourierBills().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierBills/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierBills of Courier.
     */
    async courierPrototypeCountCourierBills(requestParameters: CourierPrototypeCountCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierPrototypeCountCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts couriers of Plan.
     */
    async courierPrototypeCountPlanCouriersRaw(requestParameters: CourierPrototypeCountPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCountPlanCouriers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/plan/couriers/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts couriers of Plan.
     */
    async courierPrototypeCountPlanCouriers(requestParameters: CourierPrototypeCountPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierPrototypeCountPlanCouriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts pushSubscribers of Courier.
     */
    async courierPrototypeCountPushSubscribersRaw(requestParameters: CourierPrototypeCountPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCountPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/pushSubscribers/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts pushSubscribers of Courier.
     */
    async courierPrototypeCountPushSubscribers(requestParameters: CourierPrototypeCountPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierPrototypeCountPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async courierPrototypeCountRewardsAccountsRaw(requestParameters: CourierPrototypeCountRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCountRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/rewardsAccounts/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async courierPrototypeCountRewardsAccounts(requestParameters: CourierPrototypeCountRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierPrototypeCountRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts storeLocations of Courier.
     */
    async courierPrototypeCountStoreLocationsRaw(requestParameters: CourierPrototypeCountStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCountStoreLocations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts storeLocations of Courier.
     */
    async courierPrototypeCountStoreLocations(requestParameters: CourierPrototypeCountStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.courierPrototypeCountStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in couponCodes of this model.
     */
    async courierPrototypeCreateCouponCodesRaw(requestParameters: CourierPrototypeCreateCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCouponCodeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in couponCodes of this model.
     */
    async courierPrototypeCreateCouponCodes(requestParameters: CourierPrototypeCreateCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.courierPrototypeCreateCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierBills of this model.
     */
    async courierPrototypeCreateCourierBillsRaw(requestParameters: CourierPrototypeCreateCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/courierBills`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierBillToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierBillFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierBills of this model.
     */
    async courierPrototypeCreateCourierBills(requestParameters: CourierPrototypeCreateCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierBill> {
        const response = await this.courierPrototypeCreateCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async courierPrototypeCreateCourierSettingRaw(requestParameters: CourierPrototypeCreateCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async courierPrototypeCreateCourierSetting(requestParameters: CourierPrototypeCreateCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.courierPrototypeCreateCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async courierPrototypeCreateMailOptionRaw(requestParameters: CourierPrototypeCreateMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async courierPrototypeCreateMailOption(requestParameters: CourierPrototypeCreateMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.courierPrototypeCreateMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in oneSignalCredentials of this model.
     */
    async courierPrototypeCreateOneSignalCredentialsRaw(requestParameters: CourierPrototypeCreateOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OneSignal>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateOneSignalCredentials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/oneSignalCredentials`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OneSignalToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OneSignalFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in oneSignalCredentials of this model.
     */
    async courierPrototypeCreateOneSignalCredentials(requestParameters: CourierPrototypeCreateOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OneSignal> {
        const response = await this.courierPrototypeCreateOneSignalCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in couriers of this model.
     */
    async courierPrototypeCreatePlanCouriersRaw(requestParameters: CourierPrototypeCreatePlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreatePlanCouriers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/plan/couriers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in couriers of this model.
     */
    async courierPrototypeCreatePlanCouriers(requestParameters: CourierPrototypeCreatePlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPrototypeCreatePlanCouriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in pushSubscribers of this model.
     */
    async courierPrototypeCreatePushSubscribersRaw(requestParameters: CourierPrototypeCreatePushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreatePushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewPushSubscriptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in pushSubscribers of this model.
     */
    async courierPrototypeCreatePushSubscribers(requestParameters: CourierPrototypeCreatePushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.courierPrototypeCreatePushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async courierPrototypeCreateRewardSettingRaw(requestParameters: CourierPrototypeCreateRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardSetting of this model.
     */
    async courierPrototypeCreateRewardSetting(requestParameters: CourierPrototypeCreateRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.courierPrototypeCreateRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async courierPrototypeCreateRewardsAccountsRaw(requestParameters: CourierPrototypeCreateRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async courierPrototypeCreateRewardsAccounts(requestParameters: CourierPrototypeCreateRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.courierPrototypeCreateRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in storeLocations of this model.
     */
    async courierPrototypeCreateStoreLocationsRaw(requestParameters: CourierPrototypeCreateStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewStoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in storeLocations of this model.
     */
    async courierPrototypeCreateStoreLocations(requestParameters: CourierPrototypeCreateStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.courierPrototypeCreateStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in themeSetting of this model.
     */
    async courierPrototypeCreateThemeSettingRaw(requestParameters: CourierPrototypeCreateThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeCreateThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in themeSetting of this model.
     */
    async courierPrototypeCreateThemeSetting(requestParameters: CourierPrototypeCreateThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.courierPrototypeCreateThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all couponCodes of this model.
     */
    async courierPrototypeDeleteCouponCodesRaw(requestParameters: CourierPrototypeDeleteCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDeleteCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all couponCodes of this model.
     */
    async courierPrototypeDeleteCouponCodes(requestParameters: CourierPrototypeDeleteCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDeleteCouponCodesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierBills of this model.
     */
    async courierPrototypeDeleteCourierBillsRaw(requestParameters: CourierPrototypeDeleteCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDeleteCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierBills`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierBills of this model.
     */
    async courierPrototypeDeleteCourierBills(requestParameters: CourierPrototypeDeleteCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDeleteCourierBillsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all couriers of this model.
     */
    async courierPrototypeDeletePlanCouriersRaw(requestParameters: CourierPrototypeDeletePlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDeletePlanCouriers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/plan/couriers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all couriers of this model.
     */
    async courierPrototypeDeletePlanCouriers(requestParameters: CourierPrototypeDeletePlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDeletePlanCouriersRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all pushSubscribers of this model.
     */
    async courierPrototypeDeletePushSubscribersRaw(requestParameters: CourierPrototypeDeletePushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDeletePushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all pushSubscribers of this model.
     */
    async courierPrototypeDeletePushSubscribers(requestParameters: CourierPrototypeDeletePushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDeletePushSubscribersRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async courierPrototypeDeleteRewardsAccountsRaw(requestParameters: CourierPrototypeDeleteRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDeleteRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async courierPrototypeDeleteRewardsAccounts(requestParameters: CourierPrototypeDeleteRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDeleteRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all storeLocations of this model.
     */
    async courierPrototypeDeleteStoreLocationsRaw(requestParameters: CourierPrototypeDeleteStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDeleteStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all storeLocations of this model.
     */
    async courierPrototypeDeleteStoreLocations(requestParameters: CourierPrototypeDeleteStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDeleteStoreLocationsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for couponCodes.
     */
    async courierPrototypeDestroyByIdCouponCodesRaw(requestParameters: CourierPrototypeDestroyByIdCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyByIdCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeDestroyByIdCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for couponCodes.
     */
    async courierPrototypeDestroyByIdCouponCodes(requestParameters: CourierPrototypeDestroyByIdCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyByIdCouponCodesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierBills.
     */
    async courierPrototypeDestroyByIdCourierBillsRaw(requestParameters: CourierPrototypeDestroyByIdCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyByIdCourierBills().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeDestroyByIdCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierBills/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierBills.
     */
    async courierPrototypeDestroyByIdCourierBills(requestParameters: CourierPrototypeDestroyByIdCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyByIdCourierBillsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for couriers.
     */
    async courierPrototypeDestroyByIdPlanCouriersRaw(requestParameters: CourierPrototypeDestroyByIdPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyByIdPlanCouriers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeDestroyByIdPlanCouriers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/plan/couriers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for couriers.
     */
    async courierPrototypeDestroyByIdPlanCouriers(requestParameters: CourierPrototypeDestroyByIdPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyByIdPlanCouriersRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for pushSubscribers.
     */
    async courierPrototypeDestroyByIdPushSubscribersRaw(requestParameters: CourierPrototypeDestroyByIdPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyByIdPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeDestroyByIdPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for pushSubscribers.
     */
    async courierPrototypeDestroyByIdPushSubscribers(requestParameters: CourierPrototypeDestroyByIdPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyByIdPushSubscribersRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async courierPrototypeDestroyByIdRewardsAccountsRaw(requestParameters: CourierPrototypeDestroyByIdRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyByIdRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeDestroyByIdRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async courierPrototypeDestroyByIdRewardsAccounts(requestParameters: CourierPrototypeDestroyByIdRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyByIdRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for storeLocations.
     */
    async courierPrototypeDestroyByIdStoreLocationsRaw(requestParameters: CourierPrototypeDestroyByIdStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyByIdStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeDestroyByIdStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for storeLocations.
     */
    async courierPrototypeDestroyByIdStoreLocations(requestParameters: CourierPrototypeDestroyByIdStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyByIdStoreLocationsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async courierPrototypeDestroyCourierSettingRaw(requestParameters: CourierPrototypeDestroyCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async courierPrototypeDestroyCourierSetting(requestParameters: CourierPrototypeDestroyCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes mailOption of this model.
     */
    async courierPrototypeDestroyMailOptionRaw(requestParameters: CourierPrototypeDestroyMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes mailOption of this model.
     */
    async courierPrototypeDestroyMailOption(requestParameters: CourierPrototypeDestroyMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyMailOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes oneSignalCredentials of this model.
     */
    async courierPrototypeDestroyOneSignalCredentialsRaw(requestParameters: CourierPrototypeDestroyOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyOneSignalCredentials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/oneSignalCredentials`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes oneSignalCredentials of this model.
     */
    async courierPrototypeDestroyOneSignalCredentials(requestParameters: CourierPrototypeDestroyOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyOneSignalCredentialsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async courierPrototypeDestroyRewardSettingRaw(requestParameters: CourierPrototypeDestroyRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes rewardSetting of this model.
     */
    async courierPrototypeDestroyRewardSetting(requestParameters: CourierPrototypeDestroyRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyRewardSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes themeSetting of this model.
     */
    async courierPrototypeDestroyThemeSettingRaw(requestParameters: CourierPrototypeDestroyThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeDestroyThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes themeSetting of this model.
     */
    async courierPrototypeDestroyThemeSetting(requestParameters: CourierPrototypeDestroyThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.courierPrototypeDestroyThemeSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Find a related item by id for couponCodes.
     */
    async courierPrototypeFindByIdCouponCodesRaw(requestParameters: CourierPrototypeFindByIdCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeFindByIdCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeFindByIdCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for couponCodes.
     */
    async courierPrototypeFindByIdCouponCodes(requestParameters: CourierPrototypeFindByIdCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.courierPrototypeFindByIdCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierBills.
     */
    async courierPrototypeFindByIdCourierBillsRaw(requestParameters: CourierPrototypeFindByIdCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeFindByIdCourierBills().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeFindByIdCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierBills/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierBillFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierBills.
     */
    async courierPrototypeFindByIdCourierBills(requestParameters: CourierPrototypeFindByIdCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierBill> {
        const response = await this.courierPrototypeFindByIdCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for couriers.
     */
    async courierPrototypeFindByIdPlanCouriersRaw(requestParameters: CourierPrototypeFindByIdPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeFindByIdPlanCouriers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeFindByIdPlanCouriers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/plan/couriers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for couriers.
     */
    async courierPrototypeFindByIdPlanCouriers(requestParameters: CourierPrototypeFindByIdPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPrototypeFindByIdPlanCouriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for pushSubscribers.
     */
    async courierPrototypeFindByIdPushSubscribersRaw(requestParameters: CourierPrototypeFindByIdPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeFindByIdPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeFindByIdPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for pushSubscribers.
     */
    async courierPrototypeFindByIdPushSubscribers(requestParameters: CourierPrototypeFindByIdPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.courierPrototypeFindByIdPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async courierPrototypeFindByIdRewardsAccountsRaw(requestParameters: CourierPrototypeFindByIdRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeFindByIdRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeFindByIdRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async courierPrototypeFindByIdRewardsAccounts(requestParameters: CourierPrototypeFindByIdRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.courierPrototypeFindByIdRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for storeLocations.
     */
    async courierPrototypeFindByIdStoreLocationsRaw(requestParameters: CourierPrototypeFindByIdStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeFindByIdStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeFindByIdStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for storeLocations.
     */
    async courierPrototypeFindByIdStoreLocations(requestParameters: CourierPrototypeFindByIdStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.courierPrototypeFindByIdStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries couponCodes of Courier.
     */
    async courierPrototypeGetCouponCodesRaw(requestParameters: CourierPrototypeGetCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CouponCode>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetCouponCodes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CouponCodeFromJSON));
    }

    /**
     * Queries couponCodes of Courier.
     */
    async courierPrototypeGetCouponCodes(requestParameters: CourierPrototypeGetCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CouponCode>> {
        const response = await this.courierPrototypeGetCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierPrototypeGetCouponCodesCourierRaw(requestParameters: CourierPrototypeGetCouponCodesCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetCouponCodesCourier().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling courierPrototypeGetCouponCodesCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes/{nk}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierPrototypeGetCouponCodesCourier(requestParameters: CourierPrototypeGetCouponCodesCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPrototypeGetCouponCodesCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierBills of Courier.
     */
    async courierPrototypeGetCourierBillsRaw(requestParameters: CourierPrototypeGetCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierBill>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetCourierBills().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierBills`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierBillFromJSON));
    }

    /**
     * Queries courierBills of Courier.
     */
    async courierPrototypeGetCourierBills(requestParameters: CourierPrototypeGetCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierBill>> {
        const response = await this.courierPrototypeGetCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async courierPrototypeGetCourierSettingRaw(requestParameters: CourierPrototypeGetCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async courierPrototypeGetCourierSetting(requestParameters: CourierPrototypeGetCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.courierPrototypeGetCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierPrototypeGetCourierSettingCourierRaw(requestParameters: CourierPrototypeGetCourierSettingCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetCourierSettingCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/courierSetting/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierPrototypeGetCourierSettingCourier(requestParameters: CourierPrototypeGetCourierSettingCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPrototypeGetCourierSettingCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async courierPrototypeGetMailOptionRaw(requestParameters: CourierPrototypeGetMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetMailOption().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async courierPrototypeGetMailOption(requestParameters: CourierPrototypeGetMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.courierPrototypeGetMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation oneSignalCredentials.
     */
    async courierPrototypeGetOneSignalCredentialsRaw(requestParameters: CourierPrototypeGetOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OneSignal>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetOneSignalCredentials().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/oneSignalCredentials`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OneSignalFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation oneSignalCredentials.
     */
    async courierPrototypeGetOneSignalCredentials(requestParameters: CourierPrototypeGetOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OneSignal> {
        const response = await this.courierPrototypeGetOneSignalCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation plan.
     */
    async courierPrototypeGetPlanRaw(requestParameters: CourierPrototypeGetPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Plan>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetPlan().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/plan`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation plan.
     */
    async courierPrototypeGetPlan(requestParameters: CourierPrototypeGetPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Plan> {
        const response = await this.courierPrototypeGetPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries couriers of Plan.
     */
    async courierPrototypeGetPlanCouriersRaw(requestParameters: CourierPrototypeGetPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Courier>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetPlanCouriers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/plan/couriers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierFromJSON));
    }

    /**
     * Queries couriers of Plan.
     */
    async courierPrototypeGetPlanCouriers(requestParameters: CourierPrototypeGetPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Courier>> {
        const response = await this.courierPrototypeGetPlanCouriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries pushSubscribers of Courier.
     */
    async courierPrototypeGetPushSubscribersRaw(requestParameters: CourierPrototypeGetPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PushSubscription>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/pushSubscribers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PushSubscriptionFromJSON));
    }

    /**
     * Queries pushSubscribers of Courier.
     */
    async courierPrototypeGetPushSubscribers(requestParameters: CourierPrototypeGetPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PushSubscription>> {
        const response = await this.courierPrototypeGetPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async courierPrototypeGetRewardSettingRaw(requestParameters: CourierPrototypeGetRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetRewardSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation rewardSetting.
     */
    async courierPrototypeGetRewardSetting(requestParameters: CourierPrototypeGetRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.courierPrototypeGetRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async courierPrototypeGetRewardsAccountsRaw(requestParameters: CourierPrototypeGetRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardsAccount>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardsAccountFromJSON));
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async courierPrototypeGetRewardsAccounts(requestParameters: CourierPrototypeGetRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardsAccount>> {
        const response = await this.courierPrototypeGetRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries storeLocations of Courier.
     */
    async courierPrototypeGetStoreLocationsRaw(requestParameters: CourierPrototypeGetStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StoreLocation>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetStoreLocations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StoreLocationFromJSON));
    }

    /**
     * Queries storeLocations of Courier.
     */
    async courierPrototypeGetStoreLocations(requestParameters: CourierPrototypeGetStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StoreLocation>> {
        const response = await this.courierPrototypeGetStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierPrototypeGetStoreLocationsCourierRaw(requestParameters: CourierPrototypeGetStoreLocationsCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetStoreLocationsCourier().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling courierPrototypeGetStoreLocationsCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations/{nk}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async courierPrototypeGetStoreLocationsCourier(requestParameters: CourierPrototypeGetStoreLocationsCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPrototypeGetStoreLocationsCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation themeSetting.
     */
    async courierPrototypeGetThemeSettingRaw(requestParameters: CourierPrototypeGetThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeGetThemeSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/{id}/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation themeSetting.
     */
    async courierPrototypeGetThemeSetting(requestParameters: CourierPrototypeGetThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.courierPrototypeGetThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async courierPrototypePatchAttributesRaw(requestParameters: CourierPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async courierPrototypePatchAttributes(requestParameters: CourierPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for couponCodes.
     */
    async courierPrototypeUpdateByIdCouponCodesRaw(requestParameters: CourierPrototypeUpdateByIdCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponCode>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateByIdCouponCodes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeUpdateByIdCouponCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/couponCodes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CouponCodeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponCodeFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for couponCodes.
     */
    async courierPrototypeUpdateByIdCouponCodes(requestParameters: CourierPrototypeUpdateByIdCouponCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponCode> {
        const response = await this.courierPrototypeUpdateByIdCouponCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierBills.
     */
    async courierPrototypeUpdateByIdCourierBillsRaw(requestParameters: CourierPrototypeUpdateByIdCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierBill>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateByIdCourierBills().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeUpdateByIdCourierBills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/courierBills/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierBillToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierBillFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierBills.
     */
    async courierPrototypeUpdateByIdCourierBills(requestParameters: CourierPrototypeUpdateByIdCourierBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierBill> {
        const response = await this.courierPrototypeUpdateByIdCourierBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for couriers.
     */
    async courierPrototypeUpdateByIdPlanCouriersRaw(requestParameters: CourierPrototypeUpdateByIdPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateByIdPlanCouriers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeUpdateByIdPlanCouriers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/plan/couriers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for couriers.
     */
    async courierPrototypeUpdateByIdPlanCouriers(requestParameters: CourierPrototypeUpdateByIdPlanCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierPrototypeUpdateByIdPlanCouriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for pushSubscribers.
     */
    async courierPrototypeUpdateByIdPushSubscribersRaw(requestParameters: CourierPrototypeUpdateByIdPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSubscription>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateByIdPushSubscribers().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeUpdateByIdPushSubscribers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/pushSubscribers/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PushSubscriptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for pushSubscribers.
     */
    async courierPrototypeUpdateByIdPushSubscribers(requestParameters: CourierPrototypeUpdateByIdPushSubscribersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSubscription> {
        const response = await this.courierPrototypeUpdateByIdPushSubscribersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async courierPrototypeUpdateByIdRewardsAccountsRaw(requestParameters: CourierPrototypeUpdateByIdRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateByIdRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeUpdateByIdRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async courierPrototypeUpdateByIdRewardsAccounts(requestParameters: CourierPrototypeUpdateByIdRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.courierPrototypeUpdateByIdRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for storeLocations.
     */
    async courierPrototypeUpdateByIdStoreLocationsRaw(requestParameters: CourierPrototypeUpdateByIdStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreLocation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateByIdStoreLocations().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling courierPrototypeUpdateByIdStoreLocations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/storeLocations/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StoreLocationToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreLocationFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for storeLocations.
     */
    async courierPrototypeUpdateByIdStoreLocations(requestParameters: CourierPrototypeUpdateByIdStoreLocationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreLocation> {
        const response = await this.courierPrototypeUpdateByIdStoreLocationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update courierSetting of this model.
     */
    async courierPrototypeUpdateCourierSettingRaw(requestParameters: CourierPrototypeUpdateCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async courierPrototypeUpdateCourierSetting(requestParameters: CourierPrototypeUpdateCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.courierPrototypeUpdateCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mailOption of this model.
     */
    async courierPrototypeUpdateMailOptionRaw(requestParameters: CourierPrototypeUpdateMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Update mailOption of this model.
     */
    async courierPrototypeUpdateMailOption(requestParameters: CourierPrototypeUpdateMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.courierPrototypeUpdateMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update oneSignalCredentials of this model.
     */
    async courierPrototypeUpdateOneSignalCredentialsRaw(requestParameters: CourierPrototypeUpdateOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OneSignal>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateOneSignalCredentials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/oneSignalCredentials`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OneSignalToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OneSignalFromJSON(jsonValue));
    }

    /**
     * Update oneSignalCredentials of this model.
     */
    async courierPrototypeUpdateOneSignalCredentials(requestParameters: CourierPrototypeUpdateOneSignalCredentialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OneSignal> {
        const response = await this.courierPrototypeUpdateOneSignalCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rewardSetting of this model.
     */
    async courierPrototypeUpdateRewardSettingRaw(requestParameters: CourierPrototypeUpdateRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateRewardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/rewardSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSettingsFromJSON(jsonValue));
    }

    /**
     * Update rewardSetting of this model.
     */
    async courierPrototypeUpdateRewardSetting(requestParameters: CourierPrototypeUpdateRewardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSettings> {
        const response = await this.courierPrototypeUpdateRewardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update themeSetting of this model.
     */
    async courierPrototypeUpdateThemeSettingRaw(requestParameters: CourierPrototypeUpdateThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierPrototypeUpdateThemeSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/themeSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Update themeSetting of this model.
     */
    async courierPrototypeUpdateThemeSetting(requestParameters: CourierPrototypeUpdateThemeSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.courierPrototypeUpdateThemeSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierRegenerateMarketingInfoRaw(requestParameters: CourierRegenerateMarketingInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['courierRegenerateMarketingInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'courierRegenerateMarketingInfoRequest',
                'Required parameter "courierRegenerateMarketingInfoRequest" was null or undefined when calling courierRegenerateMarketingInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/regenerate-marketing-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierRegenerateMarketingInfoRequestToJSON(requestParameters['courierRegenerateMarketingInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async courierRegenerateMarketingInfo(requestParameters: CourierRegenerateMarketingInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.courierRegenerateMarketingInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierReplaceByIdPostCouriersidReplaceRaw(requestParameters: CourierReplaceByIdPostCouriersidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierReplaceByIdPostCouriersidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierReplaceByIdPostCouriersidReplace(requestParameters: CourierReplaceByIdPostCouriersidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierReplaceByIdPostCouriersidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierReplaceByIdPutCouriersidRaw(requestParameters: CourierReplaceByIdPutCouriersidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling courierReplaceByIdPutCouriersid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async courierReplaceByIdPutCouriersid(requestParameters: CourierReplaceByIdPutCouriersidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierReplaceByIdPutCouriersidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierReplaceOrCreatePostCouriersReplaceOrCreateRaw(requestParameters: CourierReplaceOrCreatePostCouriersReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierReplaceOrCreatePostCouriersReplaceOrCreate(requestParameters: CourierReplaceOrCreatePostCouriersReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierReplaceOrCreatePostCouriersReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierReplaceOrCreatePutCouriersRaw(requestParameters: CourierReplaceOrCreatePutCouriersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async courierReplaceOrCreatePutCouriers(requestParameters: CourierReplaceOrCreatePutCouriersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierReplaceOrCreatePutCouriersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async courierShowRatesRaw(requestParameters: CourierShowRatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/showRates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierUserCreateWhatsAppUserRequestToJSON(requestParameters['courierUserCreateWhatsAppUserRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async courierShowRates(requestParameters: CourierShowRatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.courierShowRatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async courierUpdateAllRaw(requestParameters: CourierUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async courierUpdateAll(requestParameters: CourierUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.courierUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async courierUpsertWithWhereRaw(requestParameters: CourierUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async courierUpsertWithWhere(requestParameters: CourierUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }


    /**
     * 
     */
    async getMailgunStatsRaw(courierId: number, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/${courierId}/mailgun-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
    }

    async getMailgunStats(courierId: number, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = await this.getMailgunStatsRaw(courierId, initOverrides);
        return await response.value();
    }

    /**
     * Update the onboarding status for a courier
     */
    async courierUpdateOnboardingStatusRaw(requestParameters: CourierUpdateOnboardingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling courierUpdateOnboardingStatus().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling courierUpdateOnboardingStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/Couriers/updateOnboardingStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: {
                courierId: requestParameters['courierId'],
                status: requestParameters['status'],
            },
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Update the onboarding status for a courier
     */
    async courierUpdateOnboardingStatus(requestParameters: CourierUpdateOnboardingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.courierUpdateOnboardingStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List curated gallery images from ImageKit for marketing page builder
     */
    async getMarketingGalleryImagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImageGalleryItem[]>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/Couriers/marketing-gallery-images`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<ImageGalleryItem[]>(response);
    }

    /**
     * List curated gallery images from ImageKit for marketing page builder
     */
    async getMarketingGalleryImages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImageGalleryItem[]> {
        const response = await this.getMarketingGalleryImagesRaw(initOverrides);
        return await response.value();
    }

}
